// extracted by mini-css-extract-plugin
export var marathonTags = "direction-list-module--marathon-tags--l922X";